<script setup lang="ts">
import { onMounted } from 'vue';
const emit = defineEmits(['auto']);
const props = defineProps<{ stepIndex: number }>();
onMounted(() => {
    setTimeout(() => {
        emit('auto', props.stepIndex);
    }, 100); // 0.1초 후 자동 진행
});
</script>
<template></template>
